import { Outlet, useMatchRoute, useNavigate } from '@tanstack/react-router';

import {
    Sheet,
    SheetBackButton,
    SheetContent,
    SheetHeader,
    SheetTitle,
} from '@nesso/ui/primitives/sheet';

export function SettingsLayoutSheet() {
    // react compiler issue : isn't work correctly with useMatchRoute
    'use no memo';
    const navigate = useNavigate();
    const matchRoute = useMatchRoute();

    const isOpen = !matchRoute({ to: '/settings', includeSearch: false });

    const goBackToSettings = () => {
        void navigate({ to: '/settings' });
    };

    return (
        <Sheet open={isOpen} onOpenChange={(open) => !open && goBackToSettings()}>
            <SheetContent
                className="bg-background"
                side="right"
                size="full"
                showCloseButton={false}
                onInteractOutside={(event) => event.preventDefault()}
            >
                <SheetHeader variant="mini" className="pl-2 sm:pl-8">
                    <SheetBackButton
                        className="[&_svg]:size-5"
                        onClick={goBackToSettings}
                        aria-label="Back to settings"
                    />
                    <SheetTitle className="sr-only">Settings</SheetTitle>
                </SheetHeader>
                <div className="flex flex-1 flex-col items-center overflow-y-auto">
                    <Outlet />
                </div>
            </SheetContent>
        </Sheet>
    );
}
